module.exports = __webpack_public_path__ + "img/tu07.ee39360f.png";